import { render } from "./PatientVendor.vue?vue&type=template&id=08ad9728&ts=true"
import script from "./PatientVendor.ts?vue&type=script&lang=ts&external"
export * from "./PatientVendor.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__